import { render, staticRenderFns } from "./AppAnomaliasFieldDetailsDialog.vue?vue&type=template&id=3bc79be6&scoped=true&"
import script from "./AppAnomaliasFieldDetailsDialog.vue?vue&type=script&lang=js&"
export * from "./AppAnomaliasFieldDetailsDialog.vue?vue&type=script&lang=js&"
import style0 from "./AppAnomaliasFieldDetailsDialog.vue?vue&type=style&index=0&id=3bc79be6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bc79be6",
  null
  
)

export default component.exports